import { render, staticRenderFns } from "./BadgesList.vue?vue&type=template&id=684e60f4&"
import script from "./BadgesList.vue?vue&type=script&lang=js&"
export * from "./BadgesList.vue?vue&type=script&lang=js&"
import style0 from "./BadgesList.vue?vue&type=style&index=0&id=684e60f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports